module.exports = __webpack_public_path__ + "static/img/s168.8b19dd59.png";